import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import RevenueList from './RevenueList';

export default {
    list: RevenueList,
    TransactionIcon: KeyboardArrowRightIcon,
};
